const InvitationPlusIcon = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="26.0749"
        height="26.0749"
        rx="6.53129"
        fill="url(#paint0_linear_2181_1102)"
      />
      <rect
        width="26.0749"
        height="26.0749"
        rx="6.53129"
        fill="black"
        fill-opacity="0.1"
      />
      <path
        d="M12.0098 6.53113H14.0643V19.5434H12.0098V6.53113Z"
        fill="white"
      />
      <path d="M6.53125 12.01H19.5435V14.0646H6.53125V12.01Z" fill="white" />
      <defs>
        <linearGradient
          id="paint0_linear_2181_1102"
          x1="5.35725"
          y1="7.29697e-08"
          x2="29.1641"
          y2="26.672"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#026051" />
          <stop offset="1" stop-color="#3B5F59" stop-opacity="0" />
          <stop offset="1" stop-color="#47A092" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default InvitationPlusIcon;
